<template>
  <div>
    <Label
      v-if="label"
      :required="required"
      :error="error"
      class="mb-[0.1rem]"
      >{{ label }}</Label
    >
    <textarea
      class="w-full appearance-none rounded-sm border px-3 py-2 leading-tight text-gray-700 shadow-sm outline-hidden hover:border-gray-500 focus:ring-2 focus:ring-primary"
      :class="{ 'border-link-red': props.error }"
      :value="props.modelValue"
      @change="
        $emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
      @blur="($event) => $emit('blur-sm', $event)"
      :id="props.id"
      :placeholder="props.placeholder"
      :disabled="disabled"
      :rows="rows"
      :cols="cols"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
type Props = {
  id?: string;
  label?: string;
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  rows?: number;
  cols?: number;
};
const props = withDefaults(defineProps<Props>(), {
  id: "",
  label: "",
  modelValue: "",
  placeholder: "",
  disabled: false,
  error: false,
  required: false,
  rows: 3,
  cols: 50,
});
</script>
